// extracted by mini-css-extract-plugin
export default {"table":"TicketExchangeConfirmationSummary_table__TnP0-"};